import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import theme from 'src/styles/theme';
import { ExpandedGradientCheckbox } from '../gradients/ExpandedGradientCheckbox';
import { Link } from '../Link';

export type AuthenticationAgreementsFormValues = {
  agreedPrivacyPolicy: boolean;
  agreedTermsOfUse: boolean;
  agreed13OrOlder: boolean;
};

// Maps the checkbox ID to the label contents
const checkboxData: {
  [prop in keyof AuthenticationAgreementsFormValues]: JSX.Element;
} = {
  agreedPrivacyPolicy: (
    <Typography variant="body2">
      I have read and accepted the privacy policy and allow my personal data to
      be processed by BluMint.
    </Typography>
  ),
  agreedTermsOfUse: (
    <Typography variant="body2">
      I have read and accepted the <Link href="#">Terms of Use</Link>.
    </Typography>
  ),
  agreed13OrOlder: (
    <Typography variant="body2">I am 13 years or older.</Typography>
  ),
};

type AuthenticationAgreementsProps = {
  onFormChange: (valueID: string, value: boolean) => void;
  currentValues: AuthenticationAgreementsFormValues;
  shouldShowError?: boolean;
};

export function AuthenticationAgreements({
  onFormChange,
  currentValues,
  shouldShowError = false,
}: AuthenticationAgreementsProps) {
  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { id, checked } = event.target;
    onFormChange(id, checked);
  };

  return (
    <Stack>
      <FormControl>
        {Object.keys(checkboxData).map((checkboxID, index) => {
          const checkboxLabel: JSX.Element = checkboxData[`${checkboxID}`];

          return (
            <FormControlLabel
              control={
                <ExpandedGradientCheckbox
                  checkboxProps={{
                    id: checkboxID,
                    checked: currentValues[`${checkboxID}`],
                    onChange: onChange,
                  }}
                  color={'primaryHorizontal'}
                />
              }
              labelPlacement="start"
              label={checkboxLabel}
              sx={{
                ml: 0,
                mr: 0,
                flexGrow: '1',
                justifyContent: 'space-between',
                alignItems: 'baseline',
                mb: index === 0 ? 2 : 0,
              }}
              key={index}
            />
          );
        })}
      </FormControl>

      {shouldShowError && (
        <Box>
          <Typography
            variant="body2"
            color={theme.palette.error.main}
            textAlign={'center'}
          >
            Please confirm all of the above first!
          </Typography>
        </Box>
      )}
    </Stack>
  );
}
